import HomepageSlider from "@/components/homepage/HomepageSlider";
import CityCard from "@/components/homepage/cards/CityCard";
import {useCallback} from "react";
import Parallax from "@/components/other/Parallax";


export default function HomepageCitiesSection({title, subtitle, sliderItems, sliderSidebarTitle,parallaxImageUrl}) {
    const renderCityCard = useCallback((item) => <CityCard item={item} />, []);

    return (<div style={{padding: '50px 0', backgroundColor:'#1E3228'}}>
        <HomepageSlider
            items={sliderItems}
            title={title}
            subtitle={subtitle}
            sidebarTitle={sliderSidebarTitle}
            renderItem={renderCityCard}
            headerVariant={'white'}
        />
    </div>)
}
